import { type GenericMap } from "@client/types";
import { type LabelsAppState } from "@client/types/AppState/labels";
import { type I18n } from "@common/lib/i18n";

const MODULE_TYPE_TO_CATEGORY: GenericMap<string> = {
  AiChat: "AIChat",
  BlogDetailComments: "BlogComments",
  BlogDetailContent: "BlogDetail",
  BlogDetailHeader: "BlogHeader",
  Cart: "Cart",
  Checkout: "Checkout",
  CourseDetail: "Programs",
  CourseList: "Programs",
  CourseProgress: "ProgramProgress",
  Forums: "Forum",
  ForgotPassword: "PasswordReset",
  LoginForm: "Login",
  MemberAffiliate: "Offers",
  MemberAffiliateDashboard: "AffiliateDashboard",
  MemberDownloads: "Downloads",
  MemberHelpdesk: "Helpdesk",
  MemberOrders: "Orders",
  MemberProfile: "Profile",
  MemberRecurringOrders: "Subscriptions",
  MemberSurvey: "TicketFeedback",
  MemberTicketDetail: "TicketDetail",
  MemberVouchers: "Vouchers",
  MemberWallets: "Wallet",
  OptInFormV2: "OptIn",
  ProductList: "ProductCatalog",
  Purchase: "Trial",
  Register: "Registration",
  Unsubscribe: "Unsubscribe"
};
export const getLabels = (labels: LabelsAppState, moduleType: string): I18n | undefined => {
  const category = MODULE_TYPE_TO_CATEGORY[moduleType] ?? moduleType;

  return { ...labels["Global"], ...labels[category] };
};
